import * as React from 'react';
import { Button, Divider, Icon, SelectListItem } from 'kui';
import { ICardColorTagsActionProps } from './types';
import './_CardColorTagsAction.scss';
import { COLOR_TAGS_LABEL_ACTION } from '../../../wording';
import { CARD_ACTIONS_CLASS } from '../../..';

export function CardColorTagsAction({
    colorTags: _colorTags,
    onToggleColorTag,
    openColorTags,
}: ICardColorTagsActionProps) {
    const className = CARD_ACTIONS_CLASS + '-color-tags';
    const classColorTag = className + '-item';

    const [colorTags, setColorTags] = React.useState(_colorTags);
    const [colorTagName, setColorTagName] = React.useState(null);

    if (!_colorTags.length) return null;

    return (
        <>
            <SelectListItem className={className}>
                <>
                    <Button
                        className={className + '-label'}
                        variant={'text'}
                        onClick={openColorTags}
                    >
                        {colorTagName || COLOR_TAGS_LABEL_ACTION}
                    </Button>
                    <div className={className + '-items'}>
                        {colorTags.map(colorTag => (
                            <Button
                                className={`
                                ${classColorTag}
                                ${classColorTag}--${colorTag.color}
                                ${colorTag.selected ? classColorTag + '--selected' : ''}
                            `}
                                variant={'icon'}
                                onMouseEnter={() => setColorTagName(colorTag.name)}
                                onMouseLeave={() => setColorTagName(null)}
                                onClick={() => {
                                    setColorTags(colorTags.map(tag => {
                                        if (tag.id !== colorTag.id) return tag;
                                        return {
                                            ...tag,
                                            selected: !tag.selected,
                                        };
                                    }))
                                    onToggleColorTag(colorTag.id);
                                }}
                            >
                                <Icon xlink={'done'} size={16} />
                            </Button>
                        ))}
                    </div>
                </>
            </SelectListItem>
            <Divider />
        </>
    );
}
